export const regex = {
  zipCode: /^(?:0[1-9]|[1-9]\d)\d{3}$/g,
  phone: /([0]{1})([1-9]{1})[0-9]{8}/g,
  phone2: /^0[1-9](?:\d{8}|(?:\d\s?){4}\d)$/,
  // social: /([1,2,7,8]{1})[0-9]{14}/g,
  social: /[0-9a-zA-Z]{15}/g,
  siret: /\d{14}/g,
  iban: /^(?:(?:FR)\d{25})$/gim,
  bic: /^[a-z]{6}[0-9a-z]{2}([0-9a-z]{3}|x{3})?$/i,
  name: /^[a-zA-ZÀ-ÿ-.' ]*$/g,
  password: /^(?=.*\w).{5,20}$/gm,
  email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
  multiEmail: /[\w-.]+@([\w-]+\.)+[\w-]{2,4}/g,
  time: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/g,
  cesuPassword: /^(?=.*\d)(?=.*[A-Z])(?=.*\w).{6,}$/,
};
